import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import Div from "@jumbo/shared/Div";
import LoadingButton from "@mui/lab/LoadingButton";
import { Card, CardContent, Checkbox, Dialog, FormControlLabel, Typography } from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import Link from "@mui/material/Link";
import { alpha } from "@mui/material/styles";
import { postLoginUserApi } from 'api/auth';
import { swal_error, swal_success } from "app/utils/appHelpers";
import { ASSET_IMAGES } from 'app/utils/constants/paths';
import config from 'config';
import { Form, Formik } from "formik";
import * as yup from 'yup';


const validationSchema = yup.object({
    email: yup
        .string('E-Posta veya Kimlik Numaranızı Giriniz')
        .required('E-Posta veya Kimlik Numarası zorunludur'),
    password: yup
        .string('Şifrenizi giriniz')
        .required('Şifre girişi zorunludur'),
});

function LoginDialog({ open, onClose, afterLogin }) {


    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick" && "escapeKeyDown")
            return;
        onClose();
    }

    const loginUser = async (email, password) => {
        const res = await postLoginUserApi({ email, password });
        if (res.status) {
            swal_success("Hoşgeldin " + res.user.name + ", Kullanıcı girişi başarılı");

            afterLogin(res.user, res.token);

            onClose();

        } else {
            swal_error(res.message)
        }
    }

    return (
        <Dialog open={open} onClose={handleClose} disableEscapeKeyDown >

            <Div sx={{
                flex: 1,
                flexWrap: 'wrap',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                p: theme => theme.spacing(4),
            }}>

                <Card sx={{ maxWidth: '100%', width: 360, mb: 4 }}>
                    <Div sx={{ position: 'relative', height: '200px' }}>
                        <CardMedia
                            component="img"
                            alt="green iguana"
                            // height="150"

                            image={`${ASSET_IMAGES}/logos/kurulsis.png`}
                        />
                        <Div
                            sx={{
                                flex: 1,
                                inset: 0,
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: theme => alpha(theme.palette.common.black, .5),
                                p: theme => theme.spacing(3),
                            }}
                        >

                        </Div>
                    </Div>
                    <CardContent sx={{ pt: 3 }}>

                        <Formik
                            validateOnChange={true}
                            initialValues={{
                                email: '',// 'nakdag@ayk.gov.tr',
                                password: '',// '123456',
                            }}
                            validationSchema={validationSchema}
                            onSubmit={(data, { setSubmitting }) => {
                                setSubmitting(true);
                                loginUser(data.email, data.password);
                                setSubmitting(false);
                            }}
                        >
                            {({ isSubmitting }) => (
                                <Form style={{ textAlign: 'left' }} noValidate autoComplete='off'>

                                    <Div sx={{ mb: 3, mt: 1 }}>
                                        <JumboTextField
                                            fullWidth
                                            name="email"
                                            label="E-Posta veya Kimlik No"
                                        />
                                    </Div>
                                    <Div sx={{ mb: 2, mt: 1 }}>
                                        <JumboTextField
                                            fullWidth
                                            name="password"
                                            label="Şifre"
                                            type="password"
                                        />
                                    </Div>
                                    <Typography
                                        textAlign={"right"}
                                        variant={"body1"}
                                    >
                                        <Link underline="none" href={config.mainPageUrl}>Şifrenizi mi unuttunuz?</Link>
                                    </Typography>
                                    <Div sx={{ mb: 1 }}>
                                        <FormControlLabel control={<Checkbox />} label="Beni hatırla" />
                                    </Div>
                                    <LoadingButton
                                        fullWidth
                                        type="submit"
                                        variant="contained"
                                        size="large"
                                        sx={{ mb: 3 }}
                                        loading={isSubmitting}
                                    >Giriş Yap</LoadingButton>

                                </Form>
                            )}
                        </Formik>
                    </CardContent>
                </Card>

            </Div>
        </Dialog>
    )
}

export default LoginDialog